import { error as logErrorToConsole } from '@ms/yammer-console-logging';
import { getPersistedExperimentTreatment } from '@ms/yammer-data/dist/domains/experiments/selectors';
import { isNAAChannelRecommendedWithTelemetry } from '@ms/yammer-web-support/dist/metaOsHub';

import { persistConfig } from '../../persistedState';

type IsNAASupportAvailable = () => Promise<boolean>;
export const isNAASupportAvailable: IsNAASupportAvailable = async () => {
  try {
    const [isNestedAppAuthSupportFeatureEnabled, isNAAChannelRecommended] = await Promise.all([
      getPersistedExperimentTreatment(persistConfig.key, 'TeamsMetaOSNestedAuthAppSupport'),
      isNAAChannelRecommendedWithTelemetry(),
    ]);

    return !!isNestedAppAuthSupportFeatureEnabled && isNAAChannelRecommended;
  } catch (error) {
    logErrorToConsole('Error checking NAA support availability: ' + error);

    return false;
  }
};
